module.exports = __webpack_public_path__ + "static/img/アセット 39@2x.5ded40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 39@2x.png
// module id = HHvX
// module chunks = 1